import { IconInfoCircleOutline } from '@iwoca/icons';
import { Text } from '@iwoca/orion-ui';
import { FormattedMessage } from 'react-intl';
export const MobileAppWidget = () => {
    return (
        <div className="mt-2xl rounded-l bg-primary-97 p-xl">
            <Text className="mb-m text-l font-med">
                <FormattedMessage
                    id="_.credit_card.dashboard.mobile_app_title"
                    defaultMessage="View your card details and manage your card on the mobile app."
                />
            </Text>

            <div className="my-auto flex flex-row items-start gap-2xl">
                {/* App Store Section */}
                <div className="flex flex-col items-center gap-s">
                    <img
                        src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83"
                        // eslint-disable-next-line formatjs/no-literal-string-in-jsx
                        alt="Download on the App Store"
                        className="h-[60px] w-[160px] cursor-pointer"
                    />
                </div>

                {/* Google Play Section */}
                <div className="flex flex-col items-center gap-s">
                    <img
                        src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                        // eslint-disable-next-line formatjs/no-literal-string-in-jsx
                        alt="Get it on Google Play"
                        className="mt-[-10px] h-[80px] w-[200px] cursor-pointer"
                    />
                </div>
            </div>

            {/* Info Banner */}
            <div className="bg-structure-50 mt-m flex w-1/2 items-start gap-xs rounded-xs border border-secondary-80 p-m">
                <IconInfoCircleOutline className="my-auto" />
                <Text className="text-s font-med">
                    <FormattedMessage
                        id="_.credit_card.dashboard.virtual_card_info"
                        defaultMessage="Your virtual card will be available to use immediately."
                    />
                </Text>
            </div>
        </div>
    );
};
